
import React, { Component } from 'react';
import './App.css';
import './index.css';
import { Button, Modal, Glyphicon } from 'react-bootstrap';
import update from 'immutability-helper';

class FilterModal extends Component {

    constructor(props) {
        super(props);
        /* With ES6 classes (ie class FilterModal extends Component), properties of the class do not automatically bind to the React class instance.
        This is essentially needed for all functions to work */
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.setVisibility = this.setVisibility.bind(this);
        this.setVisibilityWholeCat = this.setVisibilityWholeCat.bind(this);
        this.toggleDorms = this.toggleDorms.bind(this);
        this.toggleClothingStores = this.toggleClothingStores.bind(this);
        this.toggleAthleticFacilities = this.toggleAthleticFacilities.bind(this);
        this.toggleLibrary = this.toggleLibrary.bind(this);
        this.toggleDessert = this.toggleDessert.bind(this);
        this.toggleRestaurants = this.toggleRestaurants.bind(this);
        this.toggleNightLife = this.toggleNightLife.bind(this);
        this.toggleCoffeeShops = this.toggleCoffeeShops.bind(this);
        this.toggleBestOfAA = this.toggleBestOfAA.bind(this);
        this.toggleStudySpots = this.toggleStudySpots.bind(this);
        this.toggleYogaSpots = this.toggleYogaSpots.bind(this);
        this.togglePickupSports = this.togglePickupSports.bind(this);
        this.toggleUnivBuildings = this.toggleUnivBuildings.bind(this);
        this.toggleFitnessCenters = this.toggleFitnessCenters.bind(this);
        this.toggleSunbathingSpots = this.toggleSunbathingSpots.bind(this);
        this.toggleDateSpots = this.toggleDateSpots.bind(this);
        this.toggleMovieTheaters = this.toggleMovieTheaters.bind(this);
        this.toggleLiveMusic = this.toggleLiveMusic.bind(this);
        this.toggleAcademics = this.toggleAcademics.bind(this);
        this.toggleRecAreas = this.toggleRecAreas.bind(this);
        this.toggleEntertainment = this.toggleEntertainment.bind(this);
        this.toggleMisc = this.toggleMisc.bind(this);
        this.toggleFoodDrink = this.toggleFoodDrink.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.deselectAll = this.deselectAll.bind(this);

        this.state = {
            showModal: false,

            showDorms: true,
            showAthleticFacilities: true,
            showClothingStores: true,
            showLibrary: true,

            showDessert: true,
            showNightLife: true,
            showRestaurants: true,
            showCoffeeShops: true,

            showBestOfAA: true,
            showYogaSpots: true,
            showPickupSports: true,
            showAcademics: true,
            showFitnessCenters: true,
            showStudySpots: true,
            showSunbathingSpots: true,
            showDateSpots: true,
            showMovieTheaters: true,
            showLiveMusic: true,

            showMisc: true,
            showUnivBuilding: true,
            showFoodDrink: true,
            showEntertainment: true,
            showRecArea: true
        };
    }

    open() {
        this.props.hideNavBar();
        window.location.hash = "#filter"
    }

    close() {
        window.location.hash = "";
        this.setState({ showModal: false });
    }


    // Reevaluates if each location should be visible after a filter change
    setVisibility(cat, turnOn) {
        var newMarkers = this.props.markers;
        if (turnOn) {
            for (var onKey in this.props.markers) {
                if (cat in this.props.markers[onKey].categories) {
                    if (cat === "studyspot" || cat === "datespot" || cat === "bestofaa") {
                        this.props.markers[onKey].curMisc++;
                    }
                    else {
                        this.props.markers[onKey].curCats++;
                    }
                    if (this.props.markers[onKey].curCats !== 0 || this.props.markers[onKey].curMisc !== 0) {
                        newMarkers = update(newMarkers, {
                            [onKey]: {isVisible: {$set: true}}
                        });
                    }
                }
            }
        }

        else {
            for (var offKey in this.props.markers) {
                if (cat in this.props.markers[offKey].categories) {
                    if (cat === "studyspot" || cat === "datespot" || cat === "bestofaa") {
                        this.props.markers[offKey].curMisc--;
                    }
                    else {
                        this.props.markers[offKey].curCats--;
                    }
                    if (this.props.markers[offKey].curCats === 0 && this.props.markers[offKey].curMisc === 0) {
                        newMarkers = update(newMarkers, {
                            [offKey]: {isVisible: {$set: false}}
                        });
                    }
                }
            }
        }
        this.props.setVisibility(newMarkers);
    }

    // Called when an entire category like 'recArea' or 'entertainment' is changed
    setVisibilityWholeCat(cat, turnOn) {
        var newMarkers = this.props.markers;
        if (turnOn) {
            for (var onKey in this.props.markers) {
                if (cat in this.props.markers[onKey].categories) {
                    this.props.markers[onKey].curCats = this.props.markers[onKey].totalCats;
                    if (cat === "location") {
                        this.props.markers[onKey].curMisc = this.props.markers[onKey].totalMisc;
                    }
                    newMarkers = update(newMarkers, {
                        [onKey]: {isVisible: {$set: true}}
                    });
                }
            }
        }

        else {
            for (var offKey in this.props.markers) {

                if (cat in this.props.markers[offKey].categories) {
                    this.props.markers[offKey].curCats = 0;
                    if (cat === "location") {
                        this.props.markers[offKey].curMisc = 0;
                    }
                    newMarkers = update(newMarkers, {
                        [offKey]: {isVisible: {$set: false}}
                    });
                }
            }
        }
        this.props.setVisibility(newMarkers);
    }

    toggleDorms() {
        if (!this.state.showDorms) {
            this.setState({ showDorms: true});
            this.setVisibility("dorm", true);
        }
        else {
            this.setState({ showDorms: false});
            this.setVisibility("dorm", false);
        }
    }

    toggleClothingStores() {
        if (!this.state.showClothingStores) {
            this.setState({ showClothingStores: true});
            this.setVisibility("clothingstore", true);
        }
        else {
            this.setState({ showClothingStores: false});
            this.setVisibility("clothingstore", false);
        }
    }

    toggleAthleticFacilities() {
        if (!this.state.showAthleticFacilities) {
            this.setState({ showAthleticFacilities: true});
            this.setVisibility("athleticfacility", true);
        }
        else {
            this.setState({ showAthleticFacilities: false});
            this.setVisibility("athleticfacility", false);
        }
    }

    toggleLibrary() {
        if (!this.state.showLibrary) {
            this.setState({ showLibrary: true});
            this.setVisibility("library", true);
        }
        else {
            this.setState({ showLibrary: false});
            this.setVisibility("library", false);
        }
    }

    toggleDessert() {
        if (!this.state.showDessert) {
            this.setState({ showDessert: true});
            this.setVisibility("dessert", true);
        }
        else {
            this.setState({ showDessert: false});
            this.setVisibility("dessert", false);
        }
    }

    toggleRestaurants() {
        if (!this.state.showRestaurants) {
            this.setState({ showRestaurants: true});
            this.setVisibility("restaurant", true);
        }
        else {
            this.setState({ showRestaurants: false});
            this.setVisibility("restaurant", false);
        }
    }

    toggleNightLife() {
        if (!this.state.showNightLife) {
            this.setState({ showNightLife: true});
            this.setVisibility("nightlife", true);
        }
        else {
            this.setState({ showNightLife: false});
            this.setVisibility("nightlife", false);
        }
    }

    toggleCoffeeShops() {
        if (!this.state.showCoffeeShops) {
            this.setState({ showCoffeeShops: true});
            this.setVisibility("coffeeshop", true);
        }
        else {
            this.setState({ showCoffeeShops: false});
            this.setVisibility("coffeeshop", false);
        }
    }

    toggleBestOfAA() {
        if (!this.state.showBestOfAA) {
            this.setState({ showBestOfAA: true});
            this.setVisibility("bestofaa", true);

        }
        else {
            this.setState({ showBestOfAA: false});
            this.setVisibility("bestofaa", false);
        }
    }

    toggleStudySpots() {
        if (!this.state.showStudySpots) {
            this.setState({ showStudySpots: true});
            this.setVisibility("studyspot", true);
        }
        else {
            this.setState({ showStudySpots: false});
            this.setVisibility("studyspot", false);
        }
    }

    toggleYogaSpots() {
        if (!this.state.showYogaSpots) {
            this.setState({ showYogaSpots: true});
            this.setVisibility("yogaspot", true);
        }
        else {
            this.setState({ showYogaSpots: false});
            this.setVisibility("yogaspot", false);
        }
    }

    togglePickupSports() {
        if (!this.state.showPickupSports) {
            this.setState({ showPickupSports: true});
            this.setVisibility("pickupsports", true);
        }
        else {
            this.setState({ showPickupSports: false});
            this.setVisibility("pickupsports", false);
        }
    }

    toggleUnivBuildings() {
        if (!this.state.showUnivBuilding) {
            this.setState({ showUnivBuilding: true});
            this.setVisibility("universitybuilding", true);
        }
        else {
            this.setState({ showUnivBuilding: false});
            this.setVisibility("universitybuilding", false);
        }
    }

    toggleFitnessCenters() {
        if (!this.state.showFitnessCenters) {
            this.setState({ showFitnessCenters: true});
            this.setVisibility("fitnesscenter", true);
        }
        else {
            this.setState({ showFitnessCenters: false});
            this.setVisibility("fitnesscenter", false);
        }
    }

    toggleSunbathingSpots() {
        if (!this.state.showSunbathingSpots) {
            this.setState({ showSunbathingSpots: true});
            this.setVisibility("sunbathingspot", true);
        }
        else {
            this.setState({ showSunbathingSpots: false});
            this.setVisibility("sunbathingspot", false);
        }
    }

    toggleDateSpots() {
        if (!this.state.showDateSpots) {
            this.setState({ showDateSpots: true});
            this.setVisibility("datespot", true);
        }
        else {
            this.setState({ showDateSpots: false});
            this.setVisibility("datespot", false);
        }
    }

    toggleMovieTheaters() {
        if (!this.state.showMovieTheaters) {
            this.setState({ showMovieTheaters: true});
            this.setVisibility("movietheater", true);
        }
        else {
            this.setState({ showMovieTheaters: false});
            this.setVisibility("movietheater", false);
        }
    }

    toggleLiveMusic() {
        if (!this.state.showLiveMusic) {
            this.setState({ showLiveMusic: true});
            this.setVisibility("livemusic", true);
        }
        else {
            this.setState({ showLiveMusic: false});
            this.setVisibility("livemusic", false);
        }
    }

    toggleMisc() {
        if (!this.state.showMisc) {
            this.setState({ showMisc: true});
            this.setState({ showDorms: true});
            this.setState({ showAthleticFacilities: true});
            this.setState({ showClothingStores: true});
            this.setVisibilityWholeCat("misc", true);
        }
        else {
            this.setState({ showMisc: false});
            this.setState({ showDorms: false});
            this.setState({ showAthleticFacilities: false});
            this.setState({ showClothingStores: false});
            this.setVisibilityWholeCat("misc", false);
        }
    }

    toggleAcademics() {
        if (!this.state.showAcademics) {
            this.setState({ showAcademics: true});
            this.setState({ showLibrary: true});
            this.setState({ showUnivBuilding: true});
            this.setVisibilityWholeCat("academics", true);
        }
        else {
            this.setState({ showAcademics: false});
            this.setState({ showLibrary: false});
            this.setState({ showUnivBuilding: false});
            this.setVisibilityWholeCat("academics", false);
        }
    }

    toggleRecAreas() {
        if (!this.state.showRecArea) {
            this.setState({ showRecArea: true});
            this.setState({ showFitnessCenters: true});
            this.setState({ showSunbathingSpots: true});
            this.setState({ showYogaSpots: true});
            this.setState({ showPickupSports: true});
            this.setVisibilityWholeCat("recarea", true);
        }
        else {
            this.setState({ showRecArea: false});
            this.setState({ showFitnessCenters: false});
            this.setState({ showSunbathingSpots: false});
            this.setState({ showYogaSpots: false});
            this.setState({ showPickupSports: false});
            this.setVisibilityWholeCat("recarea", false);
        }
    }

    toggleEntertainment() {
        if (!this.state.showEntertainment) {
            this.setState({ showEntertainment: true});
            this.setState({ showMovieTheaters: true});
            this.setState({ showLiveMusic: true});
            this.setState({ showNightLife: true});
            this.setVisibilityWholeCat("entertainment", true);
        }
        else {
            this.setState({ showEntertainment: false});
            this.setState({ showMovieTheaters: false});
            this.setState({ showLiveMusic: false});
            this.setState({ showNightLife: false});
            this.setVisibilityWholeCat("entertainment", false);
        }
    }

    toggleFoodDrink() {
        if (!this.state.showFoodDrink) {
            this.setState({ showFoodDrink: true});
            this.setState({ showDessert: true});
            this.setState({ showRestaurants: true});
            this.setState({ showCoffeeShops: true});
            this.setVisibilityWholeCat("fooddrink", true);
        }
        else {
            this.setState({ showFoodDrink: false})
            this.setState({ showDessert: false});
            this.setState({ showRestaurants: false});
            this.setState({ showCoffeeShops: false});
            this.setVisibilityWholeCat("fooddrink", false);
        }
    }

    selectAll() {
        this.setState({showLibrary: true});
        this.setState({showDorms: true});
        this.setState({showAthleticFacilities: true});
        this.setState({showClothingStores: true});

        this.setState({showRestaurants: true});
        this.setState({showNightLife: true});
        this.setState({showCoffeeShops: true});
        this.setState({showDessert: true});

        this.setState({showBestOfAA: true});
        this.setState({showYogaSpots: true});
        this.setState({showPickupSports: true});
        this.setState({showFitnessCenters: true});
        this.setState({showStudySpots: true});
        this.setState({showSunbathingSpots: true});
        this.setState({showDateSpots: true});
        this.setState({showMovieTheaters: true});
        this.setState({showUnivBuilding: true});
        this.setState({showLiveMusic: true});


        this.setState({showAcademics: true});
        this.setState({showRecArea: true});
        this.setState({showFoodDrink: true});
        this.setState({showEntertainment: true});
        this.setState({showMisc: true});

        this.setVisibilityWholeCat("location", true);
    }

    deselectAll() {
        this.setState({showLibrary: false});
        this.setState({showDorms: false});
        this.setState({showAthleticFacilities: false});
        this.setState({showClothingStores: false});

        this.setState({showRestaurants: false});
        this.setState({showNightLife: false});
        this.setState({showCoffeeShops: false});
        this.setState({showDessert: false});

        this.setState({showBestOfAA: false});
        this.setState({showYogaSpots: false});
        this.setState({showPickupSports: false});
        this.setState({showAcademics: false});
        this.setState({showFitnessCenters: false});
        this.setState({showStudySpots: false});
        this.setState({showSunbathingSpots: false});
        this.setState({showDateSpots: false});
        this.setState({showMovieTheaters: false});
        this.setState({showLiveMusic: false});

        this.setState({showRecArea: false});
        this.setState({showUnivBuilding: false});
        this.setState({showFoodDrink: false});
        this.setState({showEntertainment: false});
        this.setState({showMisc: false});

        this.setVisibilityWholeCat("location", false);
    }

    render() {
        return (
            <div>
                <div onClick={this.open} className="filterButton">Filter <Glyphicon glyph="filter" /></div>

                <Modal show={this.props.isFilter} onHide={this.close} className="filterModal">
                    <div id="filterModalHeader">
                        Filter
                        <Glyphicon glyph="remove" className="closeLocModal" onClick={this.close} />
                    </div>
                    <div className="filterContent">
                        <div className={this.state.showAcademics ? 'mainCategorySelected' : 'mainCategoryNotSelected'} onClick={this.toggleAcademics}>
                            <img  alt="Blue Star" src="bluestar.png" />
                            <p>Academics</p>
                            <div className={this.state.showAcademics ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showRecArea ? 'mainCategorySelected' : 'mainCategoryNotSelected'} onClick={this.toggleRecAreas}>
                            <img alt="Orange Star" src="orangestar.png" />
                            <p>Recreational</p>
                            <div className={this.state.showRecArea ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showFoodDrink ? 'mainCategorySelected' : 'mainCategoryNotSelected'} onClick={this.toggleFoodDrink}>
                            <img alt="Green Star" src="greenstar.png" />
                            <p>Food/Drink</p>
                            <div className={this.state.showFoodDrink ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showEntertainment ? 'mainCategorySelected' : 'mainCategoryNotSelected'} onClick={this.toggleEntertainment}>
                            <img alt="Yellow Star" src="yellowstar.png" />
                            <p>Entertainment</p>
                            <div className={this.state.showEntertainment ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showMisc ? 'mainCategorySelected' : 'mainCategoryNotSelected'} onClick={this.toggleMisc}>
                            <img alt="Red Star" src="redstar.png" />
                            <p>Miscellaneous</p>
                            <div className={this.state.showMisc ? 'check' : ''}></div>
                        </div>
                        <div className="categoryNotSelected blankCat1">
                        </div>
                        <div className={this.state.showAthleticFacilities ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleAthleticFacilities}>
                            <img alt="Soccer Field" src="football-field.png" />
                            <p>UofM Athletics</p>
                            <div className={this.state.showAthleticFacilities ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showNightLife ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleNightLife}>
                            <img alt="Wine" src="wine.png" />
                            <p>Bars/Clubs</p>
                            <div className={this.state.showNightLife ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showBestOfAA ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleBestOfAA}>
                            <img alt="Trophy" src="trophy.png" />
                            <p>Best of AA</p>
                            <div className={this.state.showBestOfAA ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showClothingStores ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleClothingStores}>
                            <img alt="Shirt" src="shirt.png" />
                            <p>Clothing Stores</p>
                            <div className={this.state.showClothingStores ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showCoffeeShops ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleCoffeeShops}>
                            <img alt="Coffee Mug" src="coffeeshop.png" />
                            <p>Coffee Shops</p>
                            <div className={this.state.showCoffeeShops ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showDateSpots ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleDateSpots}>
                            <img alt="Heart" src="like.png" />
                            <p>Date Spots</p>
                            <div className={this.state.showDateSpots ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showDessert ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleDessert}>
                            <img alt="Ice Cream" src="ice-cream.png" />
                            <p>Dessert</p>
                            <div className={this.state.showDessert ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showDorms ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleDorms}>
                            <img alt="Dorm Bed" src="dorm.png" />
                            <p>Dorms</p>
                            <div className={this.state.showDorms ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showFitnessCenters ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleFitnessCenters}>
                            <img alt="Dumbbell" src="dumbbell.png" />
                            <p>Fitness</p>
                            <div className={this.state.showFitnessCenters ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showLibrary ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleLibrary}>
                            <img alt="Library" src="library.png" />
                            <p>Libraries</p>
                            <div className={this.state.showLibrary ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showLiveMusic ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleLiveMusic}>
                            <img alt="Music Note" src="music-player.png" />
                            <p>Live Music</p>
                            <div className={this.state.showLiveMusic ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showMovieTheaters ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleMovieTheaters}>
                            <img alt="Clapperboard" src="movietheater.png" />
                            <p>Movies</p>
                            <div className={this.state.showMovieTheaters ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showPickupSports ? 'categorySelected' : 'categoryNotSelected'} onClick={this.togglePickupSports}>
                            <img alt="Basketball" src="basketball.png" />
                            <p>Pickup Sports</p>
                            <div className={this.state.showPickupSports ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showRestaurants ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleRestaurants}>
                            <img alt="Spoon and Fork" src="restaurant.png" />
                            <p>Restaurants</p>
                            <div className={this.state.showRestaurants ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showStudySpots ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleStudySpots}>
                            <img alt="Studying" src="studying.png" />
                            <p>Study Spots</p>
                            <div className={this.state.showStudySpots ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showSunbathingSpots ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleSunbathingSpots}>
                            <img alt="Sunbed" src="sunbed.png" />
                            <p>Sunbathing</p>
                            <div className={this.state.showSunbathingSpots ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showYogaSpots ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleYogaSpots}>
                            <img alt="Yoga Pose" src="yogaspot.png" />
                            <p>Yoga Spots</p>
                            <div className={this.state.showYogaSpots ? 'check' : ''}></div>
                        </div>
                        <div className={this.state.showUnivBuilding ? 'categorySelected' : 'categoryNotSelected'} onClick={this.toggleUnivBuildings}>
                            <img alt="School" src="school.png" />
                            <p>Univ Buildings</p>
                            <div className={this.state.showUnivBuilding ? 'check' : ''}></div>
                        </div>
                        <div className="categoryNotSelected blankCat2">
                        </div>

                        <div className="selectdeselect">
                            <Button className="select" bsStyle="success" onClick={this.selectAll}>SELECT ALL</Button>
                            <Button className="deselect" bsStyle="danger" onClick={this.deselectAll}>DESELECT ALL</Button>
                        </div>

                    </div>
                </Modal>
            </div>
        );
    }
}

export default FilterModal;



// WEBPACK FOOTER //
// ./src/FilterModal.js